export default __webpack_public_path__ + "e76fb78b30e25b8ec88932420699cd1c.svg";